export default "__VITE_ASSET__1x8oiAC0__"